import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Tag } from '@blueprintjs/core'

import styles from './customTag.module.scss'

class CustomTag extends Component {
    static propTypes = {
        color: PropTypes.oneOf(['grey', 'light-grey', 'blue']),
        size: PropTypes.oneOf(['small', 'normal']),
        className: PropTypes.string,
        children: PropTypes.node.isRequired,
        isRound: PropTypes.bool,
    }

    static defaultProps = {
        size: 'normal',
        color: 'grey',
    }

    render() {
        const {
            color,
            size,
            children,
            className,
            isRound,
            ...other
        } = this.props

        return (
            <div className={styles.customTag}>
                <Tag
                    className={classnames(className, styles.tag, {
                        [styles.small]: size === 'small',
                        [styles.normal]: size === 'normal',
                        [styles.grey]: color === 'grey',
                        [styles.lightGrey]: color === 'light-grey',
                        [styles.blue]: color === 'blue',
                    })}
                    round={isRound}
                    {...other}
                >
                    {children}
                </Tag>
            </div>
        )
    }
}

export default CustomTag
